// @flow
import React from "react";
import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoAjusteDias,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";
import { useSelector } from "react-redux";

export const processarPontualMensal = comGeradorDePeriodo((state, medidas) => {
  const edicaoMedida = getEdicaoMedida(state);
  const dataBase = getDataBaseSelecionadaAsString(state);
  const modoSeries = isModoSeries(state);

  if (modoSeries) {
    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      descricaoSelecao: "",
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  } else {
    return medidas.map(medidaSelecionada => ({
      ...medidaSelecionada,
      descricaoSelecao: "",
      periodicidade: 2,
      ajusteDias: edicaoMedida.ajusteDias,
      dataBase: dataBase,
      ...analiseValorDaMedida(medidaSelecionada, state),
    }));
  }
});

const PontualMensal = () => {
  const modoSeries = useSelector(isModoSeries);

  return (
    <>
      <SelecaoPeriodo exibirPeriodicidade={false} />
      <SelecaoAjusteDias />
      {!modoSeries && <SelecaoCasasDecimais />}
    </>
  );
};

export default PontualMensal;
